"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.deprecationWarning = deprecationWarning;
exports.deprecationError = deprecationError;
exports.deprecatedStatelessProp = exports.withDeprecatedProps = exports.deprecatedPropValues = exports.deprecatedProp = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));

var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/values"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));

require("../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _underscore = require("underscore");

function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = (0, _filter.default)(symbols).call(symbols, function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context18; (0, _forEach.default)(_context18 = ownKeys(Object(source), true)).call(_context18, function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { var _context19; (0, _forEach.default)(_context19 = ownKeys(Object(source))).call(_context19, function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

function getSubstituteMessage(sub) {
  return sub ? " Use \"".concat(sub, "\" instead.") : "";
}

function getVersionMessage(version) {
  return version ? "version ".concat(version) : "a future release";
}

function renderMessage(message) {
  return message ? " ".concat(message) : "";
}

var isDeprecatedValue = function isDeprecatedValue(propValue) {
  return function (_ref) {
    var contains = _ref.contains,
        value = _ref.value;
    return contains ? (0, _indexOf.default)(value).call(value, propValue) > -1 : (0, _underscore.isEqual)(value, propValue);
  };
};
/**
 * @desc Fires prop deprecation warning with optional substitute and version to be removed.
 *       Use this as though it were a propType.
 *
 * @param {Object} propInfo - The deprecated prop info object.
 * @param {string} propInfo.message - An optional message tacked on to the end of the warning.
 * @param {string} propInfo.substitute - What to use instead of the deprecated prop.
 * @param {string} propInfo.version - The version number when the deprecation will occur.
 *
 * @param {enum} props - props of component
 * @param {string} propName - name of prop being validated
 *
 * @returns {{}} `Prop "${propName}" is deprecated and will be removed in a future release.`
 *
 * @example:
 *          class MyComponent extends React.Component {
 *              static propTypes = {
 *                  title: deprecatedProp({
 *                      message: "Here's how you move to 4.0.0",
 *                      substitute: "aDifferentProp",
 *                      version: "4.0.0"
 *                  })
 *              }
 *          }
 */


var deprecatedProp = function deprecatedProp(_ref2) {
  var message = _ref2.message,
      substitute = _ref2.substitute,
      version = _ref2.version;
  return function (props, propName) {
    var _context, _context2;

    return props[propName] !== undefined ? new Error((0, _concat.default)(_context = "Prop \"".concat(propName, "\" is deprecated and will be removed in ")).call(_context, getVersionMessage(version), ".") + (0, _concat.default)(_context2 = "".concat(substitute ? " Use \"".concat(substitute, "\" instead.") : "")).call(_context2, renderMessage(message))) : null;
  };
};
/**
 * @desc Fires deprecation warnings for specific values of a prop with option substitutes
 *       and removal version. Use this as though it were a propType.
 *
 * @param {Object[]} propType - The regular propType validator to use. Required.
 * @param {Object[]} values - An array of deprecated value objects. These are checked for deep equality, not reference equality.
 * @param {string} value.message - An optional message tacked on to the end of the warning.
 * @param {*} values.value - The actual value being deprecated.
 * @param {*} values.substitute - The value to use instead.
 * @param {boolean} values.contains - Used for string values; if true, checks to see if value
 *      is contained in propValue instead of doing an equality check.
 * @param {string} version - The version number when the values will be deprecated. Optional.
 *
 * @param {enum} props - props of component
 * @param {string} propName - name of prop being validated
 *
 * @returns {{}} `Prop "${propName}" is deprecated and will be removed in a future release.`
 *
 * @example:
 *          class MyComponent extends React.Component {
 *              static propTypes = {
 *                  position: deprecatedPropValues({
 *                      propType: PropTypes.oneOf(["left", "top-left", "top-right"])
 *                      values: [
 *                          {
 *                              value: "top-left",
 *                              substitute: "left"
 *                          },
 *                          {
 *                              messages: "The top-right isn't part of new designs.",
 *                              value: "top-right"
 *                          }
 *                      ],
 *                      version: "4.0.0"
 *                  })
 *              }
 *          }
 */


exports.deprecatedProp = deprecatedProp;

var deprecatedPropValues = function deprecatedPropValues(_ref3) {
  var customMessage = _ref3.customMessage,
      propType = _ref3.propType,
      values = (0, _values.default)(_ref3),
      version = _ref3.version;
  return function (props, propName, componentName) {
    var _context3;

    var propValue = props[propName];
    var deprecatedValue = (0, _find.default)(values).call(values, isDeprecatedValue(propValue)); // Default to regular propType validator if no values or if no deprecated values.

    if (!deprecatedValue) {
      return _propTypes.default.checkPropTypes((0, _defineProperty3.default)({}, propName, propType), props, propName, componentName);
    }

    var message = deprecatedValue.message,
        substitute = deprecatedValue.substitute;
    var versionMessage = getVersionMessage(version);
    return new Error(customMessage || (0, _concat.default)(_context3 = "The prop value \"".concat(propValue, "\" is deprecated and will be removed in ")).call(_context3, versionMessage, ".") + "".concat(substitute ? " Use \"".concat(substitute, "\" instead.") : "") + "".concat(renderMessage(message)));
  };
};
/**
 * @desc Higher order component that fires an error if it sees a deprecated prop or if it sees a deprecated value.
 *      Stops code from running when deprecated props are used.
 * @param {Object[]} props - An array of deprecated prop objects.
 * @param {string} props.message - An optional message tacked on to the end of a prop's warning. Used when deprecating whole props.
 * @param {string} props.name - The name of the deprecated prop.
 * @param {string} props.substitute - The substitute prop to use instead. Optional- used when deprecating whole props.
 * @param {Object[]} props.values - An array of deprecated value objects; used if deprecating specific values.
 * @param {string} props.values.message - An optional message tacked on to the end of a value's warning.
 * @param {*} props.values.value - The deprecated value.
 * @param {*} props.values.substitute - The substitute for the deprecated value. Optional.
 * @param {boolean} values.contains - Used for string values; if true, checks to see if value
 *      is contained in propValue instead of doing an equality check.
 *
 * @param {{}} WrappedComponent - The component to be wrapped in this HOC
 *
 * @returns {{}} This higher order component will either throw an error or return the wrapped component.
 *
 * @example: export default withDeprecatedProps([
 *  {
 *      name: "myProp",
 *      values: [
 *          {
 *              message: "Please do not use this awful thing.",
 *              name: "aValueYouShouldNotUse",
 *              substitute: "aMuchBetterValue"
 *          },
 *      ]
 *  },
 *  {
 *      message: "More info on this prop: (link)"
 *      name: "myDeprecatedProp",
 *      substitute: "aMuchBetterProp"
 *  }
 * ])(MyComponent)
 */


exports.deprecatedPropValues = deprecatedPropValues;

var withDeprecatedProps = function withDeprecatedProps(deprecated) {
  return function (WrappedComponent) {
    return function (props) {
      var invalidProps = (0, _reduce.default)(deprecated).call(deprecated, function (acc, _ref4) {
        var name = _ref4.name,
            _ref4$values = (0, _values.default)(_ref4),
            values = _ref4$values === void 0 ? [] : _ref4$values,
            prop = (0, _objectWithoutProperties2.default)(_ref4, ["name", "values"]);

        var propValue = props[name];

        if (propValue !== undefined) {
          var _context4;

          var deprecatedValue = (0, _find.default)(values).call(values, isDeprecatedValue(propValue));
          return (0, _concat.default)(_context4 = []).call(_context4, acc, [_objectSpread(_objectSpread(_objectSpread({}, prop), deprecatedValue ? {
            deprecatedValue: _objectSpread(_objectSpread({}, deprecatedValue), {}, {
              value: propValue
            })
          } : {}), {}, {
            name: name
          })]);
        } else {
          return acc;
        }
      }, []);

      if (invalidProps.length > 0) {
        var displayName = WrappedComponent.displayName;
        var propsMessages = (0, _reduce.default)(invalidProps).call(invalidProps, function (propsMessage, _ref5) {
          var dv = _ref5.deprecatedValue,
              message = _ref5.message,
              propName = _ref5.name,
              sub = _ref5.substitute;

          if (dv !== undefined) {
            var _context5, _context6, _context7;

            return (0, _concat.default)(_context5 = (0, _concat.default)(_context6 = (0, _concat.default)(_context7 = "".concat(propsMessage, "The prop value \"")).call(_context7, dv.value, "\" is deprecated and can no longer be used.")).call(_context6, getSubstituteMessage(dv.substitute))).call(_context5, renderMessage(dv.message));
          } else {
            var _context8, _context9, _context10;

            var subMessage = sub ? "; use \"".concat(sub, "\" instead.") : ".";
            return (0, _concat.default)(_context8 = (0, _concat.default)(_context9 = (0, _concat.default)(_context10 = "".concat(propsMessage, "Prop \"")).call(_context10, propName, "\" is deprecated and can no longer be used")).call(_context9, subMessage)).call(_context8, renderMessage(message), "\n");
          }
        }, "Error in component \"".concat(displayName, "\":\n"));
        throw new Error((0, _trim.default)(propsMessages).call(propsMessages));
      } else {
        return /*#__PURE__*/_react.default.createElement(WrappedComponent, props);
      }
    };
  };
};
/**
 * @desc Function that logs a warning that a component or module will be removed in a future release.
 * @param {Object} warning - The warning object.
 * @param {string} warning.message - An optional message tacked on to the end of the warning.
 * @param {string} warning.name - The name of the module or component being deprecated.
 * @param {string} warning.substitute - The component or module to be used instead.
 * @param {string} warning.type - The type of thing being deprecated. Default is "component".
 * @param {string} warning.version - The version when the module or component will be removed. Optional.
 *
 * @returns {} No return value.
 *
 * @example: deprecationWarning({
 *      message: "Here's some information about how to get ready for next version",
 *      name: "myRegrettableComponent",
 *      substitute: "myBetterComponent",
 *      version: "4.0.0"
 *  })
 */


exports.withDeprecatedProps = withDeprecatedProps;

function deprecationWarning(_ref6) {
  var _context11, _context12, _context13, _context14;

  var message = _ref6.message,
      name = _ref6.name,
      _ref6$type = _ref6.type,
      type = _ref6$type === void 0 ? "component" : _ref6$type,
      substitute = _ref6.substitute,
      version = _ref6.version;
  console.error((0, _concat.default)(_context11 = (0, _concat.default)(_context12 = (0, _concat.default)(_context13 = (0, _concat.default)(_context14 = "The ".concat(type, " \"")).call(_context14, name, "\" is deprecated and will be removed in ")).call(_context13, getVersionMessage(version), ".")).call(_context12, getSubstituteMessage(substitute))).call(_context11, renderMessage(message)));
}
/**
 * @desc Function that logs a warning that a component or module has been removed. Causes a runtime error,
 *       which will prevent pages using the deprecated thing from loading and will fail related unit tests.
 * @param {Object} error - The error object.
 * @param {string} error.message - An optional message tacked on to the end of the warning.
 * @param {string} error.name - The name of the module or component being deprecated.
 * @param {string} error.substitute - The component or module to be used instead.
 * @param {string} error.type - The type of thing being deprecated. Default is "component".
 *
 * @returns {} No return value.
 *
 * @example: deprecationError({
 *      message: "Here's an explanation of the substitute value.",
 *      name: "myRegrettableComponent",
 *      substitute: "myBetterComponent"
 *  })
 */


function deprecationError(_ref7) {
  var _context15, _context16, _context17;

  var message = _ref7.message,
      name = _ref7.name,
      _ref7$type = _ref7.type,
      type = _ref7$type === void 0 ? "component" : _ref7$type,
      substitute = _ref7.substitute;
  throw new Error((0, _concat.default)(_context15 = (0, _concat.default)(_context16 = (0, _concat.default)(_context17 = "The ".concat(type, " \"")).call(_context17, name, "\" is deprecated and has been removed.")).call(_context16, getSubstituteMessage(substitute))).call(_context15, renderMessage(message)));
}
/**
 * @desc Prop type for deprecating the stateless prop
 */


var deprecatedStatelessProp = deprecatedProp({
  message: "Since v4.0.0, components no longer have stateful and stateless versions, " + "so this prop no longer has any effect."
});
exports.deprecatedStatelessProp = deprecatedStatelessProp;